import axios from "axios";
import { API } from "./client";

export async function listRecordings({ page = 1, limit = 10, projectId, startDate, endDate } = {}) {
  const params = { page, limit };
  if (projectId) params.projectId = projectId;
  if (startDate) params.startDate = startDate;
  if (endDate) params.endDate = endDate;
  const res = await axios.get(`${API}/recordings`, { params });
  return res.data; // { data, pagination: { totalCount, totalPages, currentPage } }
}

export async function getRecording(id) {
  const res = await axios.get(`${API}/recordings/${id}`);
  return res.data;
}

export function getRecordingAudioUrl(id) {
  return `${API}/recordings/${id}/audio`;
}

export async function uploadRecording(projectId, audioBlob, durationSeconds) {
  const formData = new FormData();
  formData.append("project_id", projectId);
  formData.append("audio", audioBlob, "recording.webm");
  if (durationSeconds != null) {
    formData.append("duration_seconds", String(Math.round(durationSeconds)));
  }
  const res = await axios.post(`${API}/recordings/upload`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
}

export async function getProjectFolders(projectId) {
  const res = await axios.get(`${API}/projects/${projectId}/folders`);
  return res.data; // { folders, onedrive_linked }
}

export async function moveRecording(id, folderId) {
  // Now uploads the recording's audio as a real OneDrive file — give it more room than the default.
  const res = await axios.patch(`${API}/recordings/${id}/move`, { folderId: folderId || null }, { timeout: 60000 });
  return res.data;
}

export async function getRecordingsByFolder(projectId, folderId) {
  const res = await axios.get(`${API}/recordings/by-folder`, {
    params: { projectId, folderId: folderId || undefined },
  });
  return res.data;
}
